const classNameValues = {
  LayoutRoot: 'lm_strelit',
  Focused: 'lm_focused',
  Item: 'lm_item',
  Items: 'lm_items',
  Stack: 'lm_stack',
  MaximisePlace: 'lm_maximise_placeholder',
  DropTabPlaceholder: 'lm_drop_tab_placeholder',
  DragHandle: 'lm_drag_handle',
  Splitter: 'lm_splitter',
  Vertical: 'lm_vertical',
  Horizontal: 'lm_horizontal',
  Dragging: 'lm_dragging',
  DragProxy: 'lm_dragProxy',
  Header: 'lm_header',
  Tabs: 'lm_tabs',
  Tab: 'lm_tab',
  CloseTab: 'lm_close_tab',
  Controls: 'lm_controls',
  TabDropdown: 'lm_tabdropdown',
  TabDropdownList: 'lm_tabdropdown_list',
  Title: 'lm_title',
  Popout: 'lm_popout',
  Popin: 'lm_popin',
  Maximise: 'lm_maximise',
  Close: 'lm_close',
  Active: 'lm_active',
  Maximised: 'lm_maximised',
  Content: 'lm_content',
  Left: 'lm_left',
  Right: 'lm_right',
  Bottom: 'lm_bottom',
  Column: 'lm_column',
  Row: 'lm_row',
  Root: 'lm_root',
  Icon: 'lm_icon',
  Bg: 'lm_bg',
  DropTargetIndicator: 'lm_dropTargetIndicator',
  Inner: 'lm_inner',
  TransitionIndicator: 'lm_transition_indicator',
} as const;

export type DomClassName =
  (typeof classNameValues)[keyof typeof classNameValues];

export const DomConstants = {
  ClassName: classNameValues,
} as const;
